// src/services/printTicket.js

export const printTicket = (saleData) => {
    if (!saleData) {
        console.error("No hay datos de venta para imprimir.");
        return;
    }

    const printWindow = window.open('', '_blank', 'width=300,height=500');
    if (!printWindow) {
        alert("Por favor, permite las ventanas emergentes para imprimir el ticket.");
        return;
    }

    const ticketHTML = `
        <html>
            <head>
                <title>Recibo de Venta</title>
                <style>
                    body {
                        width: 57mm;
                        font-family: 'Courier New', Courier, monospace;
                        font-size: 8pt;
                        color: black;
                        margin: 0;
                        padding: 3mm;
                    }
                    .center { text-align: center; }
                    .logo { width: 60%; margin: 0 auto; display: block; }
                    h1 { font-size: 10pt; margin: 5px 0; }
                    h2 { font-size: 8pt; margin: 3px 0; }
                    p { margin: 2px 0; }
                    hr { border: none; border-top: 1px dashed black; margin: 5px 0; }
                    .items-table { width: 100%; }
                    .items-table .item-row td { vertical-align: top; }
                    .items-table .item-name { width: 70%; }
                    .items-table .item-price { text-align: right; }
                    .total-row { font-weight: bold; font-size: 10pt; }
                    @media print {
                        @page {
                            margin: 0;
                            size: 57mm auto; /* Ajusta el tamaño del papel */
                        }
                        body {
                            margin: 0;
                        }
                    }
                </style>
            </head>
            <body>
                <div class="center">
                    <img src="https://points.beer/logo_pointsbeer.png" alt="Logo" class="logo" />
                    <h1>POINTS.BEER</h1>
                    <h2>${saleData.storeName || ''}</h2>
                </div>
                <p>Fecha: ${new Date(saleData.saleDate).toLocaleString()}</p>
                <p>Venta ID: ${saleData.saleId}</p>
                <hr />
                <table class="items-table">
                    <tbody>
                        ${saleData.items.map(item => `
                            <tr class="item-row">
                                <td class="item-name">${item.quantity} x ${item.name}</td>
                                <td class="item-price">$${(item.quantity * item.sale_price).toFixed(2)}</td>
                            </tr>
                        `).join('')}
                    </tbody>
                </table>
                <hr />
                <table>
                    <tbody>
                        <tr class="total-row">
                            <td>TOTAL:</td>
                            <td style="text-align: right;">$${Number(saleData.totalAmount).toFixed(2)}</td>
                        </tr>
                    </tbody>
                </table>
                <p class="center" style="margin-top: 15px;">¡GRACIAS POR SU COMPRA!</p>
            </body>
        </html>
    `;

    printWindow.document.write(ticketHTML);
    printWindow.document.close();
    printWindow.focus();
    
    // Esperamos un momento para que el contenido cargue antes de imprimir
    setTimeout(() => {
        printWindow.print();
        printWindow.close();
    }, 250);
};